import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { css } from '@emotion/react';
import { palette } from '@leafygreen-ui/palette';
import Icon from '@leafygreen-ui/icon';

// services
import { admin } from 'js/common/services/api';

// components
import Alert from 'js/common/components/Alert';

const alertStyles = css({
  color: palette.yellow.dark2,
  borderColor: palette.yellow.light2,
  background: palette.yellow.light3,
});

const messageContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
});

const iconStyles = css({
  marginRight: '8px',
  overflow: 'initial',
});

interface Message {
  _id: string;
  msg: string;
  active: boolean;
  path: string;
}

function UIMessages({ location: { pathname } = { pathname: '' } }: { location: Pick<Location, 'pathname'> }) {
  const [messages, setMessages] = useState<Array<Message>>([]);

  useEffect(() => {
    async function loadUIMessages() {
      const msgs = await admin.getUiMsgs();
      setMessages(msgs);
    }

    loadUIMessages();
  }, []);

  if (!messages.length) {
    return null;
  }

  const filterMessages = (msg) => msg.active && (!msg.path || pathname?.includes(msg.path));
  const matchedMessages = messages.filter(filterMessages);

  if (!matchedMessages.length) {
    return null;
  }

  return (
    <div className="mms-body-admin-message-container mms-body-admin-message-container-is-visible">
      <Alert level="warning" css={alertStyles}>
        {matchedMessages.map((message) => (
          <article className="admin-message" key={message._id} css={messageContainerStyles}>
            <Icon glyph="Warning" size={16} css={iconStyles} />
            <span className="admin-message-banner-content">{message.msg}</span>
          </article>
        ))}
      </Alert>
    </div>
  );
}

export default withRouter(UIMessages);
